const SYSTEMS = {
  systemattribute: 'Systemattribut|Systemattributes',
  systemgroup: 'Systemgroup|Systemgroups',
  system: 'System|Systems',
  system_advantage: 'System advantage|system advantages',
};

export default SYSTEMS;
